var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIEdit = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -108.229)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 108.229)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.108 80.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18.968,42.783h-8.866a2.276,2.276,0,0,1-2.274-2.274V32.53a2.276,2.276,0,0,1,2.274-2.274h3.989v1h-3.989a1.275,1.275,0,0,0-1.274,1.274v7.979a1.275,1.275,0,0,0,1.274,1.274h8.866a1.275,1.275,0,0,0,1.273-1.274v-3.99h1v3.99A2.276,2.276,0,0,1-18.968,42.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.853,39.527l1.24-3.721,6.278-6.33a1.743,1.743,0,0,1,1.235-.517h.008a1.733,1.733,0,0,1,1.231.508l.026.024a1.806,1.806,0,0,1-.021,2.52l-6.275,6.275Zm2.115-3.182-.533,1.6,1.6-.534,6.109-6.107a.8.8,0,0,0,.012-1.114.759.759,0,0,0-.541-.231h0a.743.743,0,0,0-.53.222Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1.225,
    transform: "translate(-19.33 31.988) rotate(-43.611)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_edit.f9383792.svg";
export { ForwardRef as ReactComponent };